var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSelect = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 160,
  height: 32,
  fill: "none"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 158,
  height: 30,
  x: 1,
  y: 1,
  fill: "var(--hop-neutral-surface)",
  stroke: "var(--hop-neutral-border-strong)",
  strokeWidth: 2,
  rx: 7
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  width: 80,
  height: 4,
  x: 15,
  y: 14,
  fill: "var(--hop-neutral-border-weak)",
  rx: 2
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "var(--hop-neutral-icon)",
  fillRule: "evenodd",
  d: "M146.03 13.575a.75.75 0 0 0-1.061 0L140 18.544l-4.969-4.97a.75.75 0 0 0-1.061 1.061l5.323 5.323a1 1 0 0 0 1.414 0l5.323-5.323a.75.75 0 0 0 0-1.06",
  clipRule: "evenodd"
})));
export default SvgSelect;